"use client";

import { useState } from "react";
import Link from "next/link";

export function Brand({
  href = "/",
  size = "header",
}: {
  href?: string;
  size?: "header" | "hero";
}) {
  const [failed, setFailed] = useState(false);

  return (
    <Link href={href} className="inline-flex items-center" aria-label="Trophytopia">
      {failed ? (
        <span className={`aurora-text logo-word ${size === "hero" ? "text-3xl sm:text-5xl" : "text-lg sm:text-xl"}`}>
          TROPHYTOPIA
        </span>
      ) : (
        <img
          src="/trophytopia-logo.png"
          alt="Trophytopia"
          width={679}
          height={661}
          onError={() => setFailed(true)}
          className={
            size === "hero"
              ? "logo-glow h-auto w-full max-w-xs sm:max-w-sm"
              : "logo-glow h-20 w-auto sm:h-24"
          }
        />
      )}
    </Link>
  );
}
